module.exports = {"150784001":"拉布大林街道","150784002":"上库力街道","150784101":"黑山头镇","150784103":"莫尔道嘎镇","150784104":"恩和哈达镇","150784200":"三河回族乡","150784210":"恩和俄罗斯族民族乡","150784211":"蒙兀室韦苏木","150784212":"奇乾乡","150784400":"内蒙古拉布大林农牧场","150784401":"内蒙古三河种马场","150784402":"内蒙古上库力农场","150784403":"内蒙古苏沁农牧场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/150784.json
// module id = 545
// module chunks = 0